import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const portfolioImages = [
    { src: '/images/IMG_0320.jpeg', alt: 'Luxury Resort Lifestyle Photography', category: 'hospitality' },
    { src: '/images/36.jpg', alt: 'Premium Yacht Photography', category: 'hospitality' },
    { src: '/images/CherokeeRose.jpg', alt: 'Artisan Bread & Cheese Photography', category: 'culinary' },
    { src: '/images/SantaMaria.jpg', alt: 'Gourmet Potato Dish Photography', category: 'culinary' },
    { src: '/images/IMG_0580.jpeg', alt: 'Herb-Crusted Chicken Photography', category: 'culinary' },
    { src: '/images/IMG_2388.JPEG', alt: 'Hawaiian Coastline Aerial Photography', category: 'aerial' },
    { src: '/images/18acresaerialview.jpg', alt: 'Expansive Land Aerial Photography', category: 'aerial' },
    { src: '/images/luxuryRealEstate5.jpg', alt: 'Luxury Home Twilight Photography', category: 'realestate' },
    { src: '/images/959_hero_atl-home2-3-20181113065824.jpg', alt: 'Magnificent Estate Photography', category: 'realestate' },
    { src: '/images/IMG_0840.jpeg', alt: 'Professional Community Entrance', category: 'realestate' },
    { src: '/images/OntherollweddingMaklawena.jpeg', alt: 'Romantic Beach Wedding Sunset Photography', category: 'wedding' },
    { src: '/images/IMG_7016.jpg', alt: 'Artistic Portrait Photography', category: 'wedding' },
    { src: '/images/i00l4873.jpg', alt: 'Professional Portrait Photography', category: 'wedding' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === portfolioImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [portfolioImages.length]);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <h2>ON THE ROLL PRODUCTIONS</h2>
            <span>Photography That Elevates Your Business</span>
          </div>
          
          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <a href="#home" onClick={() => scrollToSection('home')}>Home</a>
            <a href="#about" onClick={() => scrollToSection('about')}>About</a>
            <a href="#services" onClick={() => scrollToSection('services')}>Services</a>
            <a href="#portfolio" onClick={() => scrollToSection('portfolio')}>Portfolio</a>
            <a href="#packages" onClick={() => scrollToSection('packages')}>Packages</a>
            <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
          </div>
          
          <div className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Transform Your Business with Photography That Commands Premium Prices</h1>
            <p className="hero-subtitle">
              We infiltrate your customers' deepest desires and fantasies, transforming their emotional journey into irresistible visual magnets that compel strangers to become raving fans who eagerly pay premium prices.
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">40%</span>
                <span className="stat-label">Booking Increase</span>
              </div>
              <div className="stat">
                <span className="stat-number">300%</span>
                <span className="stat-label">Social Engagement</span>
              </div>
              <div className="stat">
                <span className="stat-number">60-90</span>
                <span className="stat-label">Days to ROI</span>
              </div>
            </div>
            <div className="hero-buttons">
              <button className="cta-primary" onClick={() => scrollToSection('contact')}>
                Schedule Your Consultation
              </button>
              <button className="cta-secondary" onClick={() => scrollToSection('portfolio')}>
                View Our Work
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img src="/images/IMG_4511.jpg" alt="Michelle & Nicholas - On the Roll Productions" />
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="problem-section">
        <div className="container">
          <h2>Your Current Photography is Silently Sabotaging Your Success</h2>
          <div className="problem-grid">
            <div className="problem-card">
              <h3>Outdated Photography is Costing You</h3>
              <p>Bland, forgettable images are silently sabotaging your revenue streams, driving potential customers straight into your competitors' arms while your authentic brand story remains invisible to the very people who would pay premium prices to experience what you offer.</p>
            </div>
            <div className="problem-card">
              <h3>Demographic Disconnect</h3>
              <p>Your outdated visuals are repelling the exact affluent clientele who would gladly invest thousands in your services, while they scroll past your business to book with competitors whose stunning imagery speaks directly to their desires and aspirations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="solution-section">
        <div className="container">
          <h2>Strategic Visual Solutions That Drive Results</h2>
          <div className="solution-grid">
            <div className="solution-card">
              <h3>Guest Perspective Photography</h3>
              <p>We infiltrate your customers' deepest desires and fantasies, transforming their emotional journey into irresistible visual magnets that compel strangers to become raving fans who can't wait to experience what you offer and eagerly pay premium prices to make it happen.</p>
            </div>
            <div className="solution-card">
              <h3>Marketing-Focused Approach</h3>
              <p>Every single image becomes a precision-crafted magnet that instantly elevates your brand above competitors while irresistibly drawing your ideal high-paying customers directly into your sales funnel, transforming casual browsers into obsessed buyers who choose you over everyone else.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>The Michelle & Nicholas Advantage</h2>
              <p className="about-intro">
                Our unique partnership combines Michelle's hospitality expertise and artistic vision with Nicholas's technical drone mastery, creating photography that drives measurable business results.
              </p>
              
              <div className="about-features">
                <div className="feature">
                  <h4>Michelle McKeon - Creative Director</h4>
                  <p>With extensive hospitality background, Michelle understands exactly what guests want to see and experience. Her artistic vision captures the emotions that drive booking decisions.</p>
                </div>
                <div className="feature">
                  <h4>Nicholas - Master Drone Pilot</h4>
                  <p>FAA certified pilot with years of experience capturing stunning aerial footage safely and legally. His technical expertise creates cinematic perspectives that wow clients.</p>
                </div>
              </div>

              <div className="credentials">
                <h4>Professional Credentials</h4>
                <ul>
                  <li>FAA Certified Drone Pilot</li>
                  <li>Hospitality Industry Experience</li>
                  <li>Professional Photography Certification</li>
                  <li>Underwater Photography Specialist</li>
                  <li>Marketing Strategy Consultant</li>
                </ul>
              </div>
            </div>
            <div className="about-image">
              <img src="/images/michelle-nicholas.jpg" alt="Michelle and Nicholas - On the Roll Productions Team" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="container">
          <h2>Comprehensive Photography Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🏨</div>
              <h3>Hospitality & Real Estate</h3>
              <p>360° virtual experiences and property documentation that increases booking rates and justifies premium pricing.</p>
              <ul>
                <li>Complete property documentation</li>
                <li>360° virtual tours</li>
                <li>Aerial drone photography</li>
                <li>Guest experience documentation</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">🍽️</div>
              <h3>Culinary Excellence</h3>
              <p>Gastronomic storytelling that increases online orders by 60% and drives restaurant reservations.</p>
              <ul>
                <li>Menu photography</li>
                <li>Lifestyle dining shots</li>
                <li>Chef portraits</li>
                <li>Behind-the-scenes content</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">🚁</div>
              <h3>Aerial & Adventure</h3>
              <p>Cinematic perspectives that attract adventure-seeking demographics and increase millennial bookings by 85%.</p>
              <ul>
                <li>Professional drone photography</li>
                <li>Action sports documentation</li>
                <li>Underwater photography</li>
                <li>Adventure storytelling</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">💒</div>
              <h3>Wedding & Events</h3>
              <p>Emotional storytelling that captures authentic moments and creates powerful marketing content for venues.</p>
              <ul>
                <li>Wedding documentation</li>
                <li>Event photography</li>
                <li>Venue marketing content</li>
                <li>Emotional storytelling</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="portfolio-section">
        <div className="container">
          <h2>Portfolio Showcase</h2>
          <div className="portfolio-grid">
            {portfolioImages.map((image, index) => (
              <div key={index} className="portfolio-item">
                <img src={image.src} alt={image.alt} />
                <div className="portfolio-overlay">
                  <h4>{image.alt}</h4>
                  <span className="category">{image.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section id="packages" className="packages-section">
        <div className="container">
          <h2>Investment Packages</h2>
          <div className="packages-grid">
            <div className="package-card">
              <h3>Essential</h3>
              <div className="package-features">
                <ul>
                  <li>Professional photography session (2-3 hours)</li>
                  <li>20 high-resolution edited images</li>
                  <li>Social media optimization</li>
                  <li>Digital gallery with sharing capabilities</li>
                </ul>
              </div>
              <p className="package-description">Perfect for businesses seeking to refresh their visual content with professional quality photography.</p>
              <button className="package-cta" onClick={() => scrollToSection('contact')}>Get Started</button>
            </div>

            <div className="package-card featured">
              <div className="popular-badge">Most Popular</div>
              <h3>Premium</h3>
              <div className="package-features">
                <ul>
                  <li>Comprehensive photography experience (6-8 hours)</li>
                  <li>50+ high-resolution edited images</li>
                  <li>Aerial drone photography included</li>
                  <li>Strategic marketing consultation</li>
                </ul>
              </div>
              <p className="package-description">Comprehensive photography solution for businesses ready to make a significant visual impact.</p>
              <button className="package-cta" onClick={() => scrollToSection('contact')}>Get Started</button>
            </div>

            <div className="package-card">
              <h3>Signature</h3>
              <div className="package-features">
                <ul>
                  <li>Multi-day content creation experience</li>
                  <li>100+ images plus video content</li>
                  <li>Complete social media strategy</li>
                  <li>Comprehensive brand documentation</li>
                </ul>
              </div>
              <p className="package-description">The ultimate package for businesses seeking to establish market dominance through exceptional visual content.</p>
              <button className="package-cta" onClick={() => scrollToSection('contact')}>Get Started</button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2>Client Success Stories</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Our investment in professional photography with On the Roll Productions resulted in a 400% ROI within three months. The quality and strategic approach exceeded our expectations."</p>
              <div className="testimonial-author">
                <strong>Jennifer Walsh</strong>
                <span>Sunset Beach Resort</span>
              </div>
            </div>

            <div className="testimonial-card">
              <p>"Our online orders increased 60% after updating our menu photography. The food literally jumps off the screen! Our customers now order dishes they never tried before."</p>
              <div className="testimonial-author">
                <strong>Chef Antonio Rossi</strong>
                <span>Bella Vista Restaurant</span>
              </div>
            </div>

            <div className="testimonial-card">
              <p>"The drone footage completely transformed our marketing. Bookings from millennials increased 85% after we started using these videos!"</p>
              <div className="testimonial-author">
                <strong>David Park</strong>
                <span>Paradise Resort Manager</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2>Ready to Transform Your Business?</h2>
              <p>Let's create photography that drives measurable business results and positions you above your competition.</p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <strong>Email:</strong>
                  <a href="mailto:michelle@ontherollproductions.com">michelle@ontherollproductions.com</a>
                </div>
                <div className="contact-item">
                  <strong>Phone:</strong>
                  <a href="tel:+12392242288">+1 239-224-2288</a>
                </div>
                <div className="contact-item">
                  <strong>Website:</strong>
                  <span>www.ontherollproductions.com</span>
                </div>
                <div className="contact-item">
                  <strong>Social:</strong>
                  <a href="https://instagram.com/ontherollproductions" target="_blank" rel="noopener noreferrer">@ontherollproductions</a>
                </div>
              </div>

              <div className="consultation-cta">
                <h3>Schedule Your Consultation</h3>
                <p>I have limited availability for consultations. Let's discuss how we can help your business achieve extraordinary results.</p>
                <a href="mailto:michelle@ontherollproductions.com?subject=Photography Consultation Request" className="cta-primary">
                  Book Your Consultation
                </a>
              </div>
            </div>

            <div className="contact-form">
              <h3>Get In Touch</h3>
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                  <input type="text" placeholder="Business Name" required />
                </div>
                <div className="form-group">
                  <select required>
                    <option value="">Select Service Type</option>
                    <option value="hospitality">Hospitality & Real Estate</option>
                    <option value="culinary">Culinary Photography</option>
                    <option value="adventure">Adventure & Aerial</option>
                    <option value="wedding">Wedding & Events</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <textarea placeholder="Tell us about your project and goals" rows="5" required></textarea>
                </div>
                <button type="submit" className="form-submit">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>ON THE ROLL PRODUCTIONS</h3>
              <p>Photography That Elevates Your Business</p>
            </div>
            <div className="footer-links">
              <a href="#home" onClick={() => scrollToSection('home')}>Home</a>
              <a href="#about" onClick={() => scrollToSection('about')}>About</a>
              <a href="#services" onClick={() => scrollToSection('services')}>Services</a>
              <a href="#portfolio" onClick={() => scrollToSection('portfolio')}>Portfolio</a>
              <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 On the Roll Productions. All rights reserved.</p>
            <p>Professional photography that drives measurable business results.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

